import axios from 'axios'
import * as CONFIG from '../config/index'
import * as helper from './helper'

export const IDEA_API_URL = `${CONFIG.API_URL}/idea`
export const STATISTIC_API_URL = `${CONFIG.API_URL}/statistic`
export const createIdea = async (idea) => {
  // try {
  //   let res = await axios.post(IDEA_API_URL, idea);
  //   if (res.data.success) {
  //     helper.successMsg('Create idea success');
  //   }
  // } catch (e) {
  //   helper.notifyError(e);
  // }
  return await axios.post(IDEA_API_URL, idea);
}

export const updateIdea = async (idea) => {
  // try {
  //   let res = await axios.put(IDEA_API_URL, idea);
  //   if (res.data.success) {
  //     helper.successMsg('Update idea success');
  //   }
  // } catch (e) {
  //   helper.notifyError(e);
  // }
  return await axios.put(IDEA_API_URL, idea)
}


export const getIdea = async (id) => {
  try {
    let res = await axios.get(`${IDEA_API_URL}/${id}`);
    return res.data.data;
  } catch (e) {
    helper.notifyError(e);
  }
}

export const getLatest = async (type, pageNo, pageSize) => {
  try {
    let res = await axios.get(`${IDEA_API_URL}/latest?type=${type}&pageNo=${pageNo}&pageSize=${pageSize}`);
    return res.data.data;
  } catch (e) {
    helper.notifyError(e);
  }
}

export const processIdea = async (form) => {
  try {
    let res = await axios.post(`${IDEA_API_URL}/process-idea`, form);
    return res.data.data;
  } catch (e) {
    helper.notifyError(e);
    return undefined;
  }
}

export const searchReviewIdea = async (form, pageNo, pageSize) => {
  try {
    const res = await axios.post(`${IDEA_API_URL}/search-review-idea?pageNo=${pageNo}&pageSize=${pageSize}`, form);
    return res.data.data;
  } catch (e) {
    return {totals: 0, items: []};
  }
}

export const searchReviewIdeaToIKhien = async (form, pageNo, pageSize) => {
  try {
    const res = await axios.post(`${IDEA_API_URL}/search-review-idea-ikhien?pageNo=${pageNo}&pageSize=${pageSize}`, form);
    return res.data.data;
  } catch (e) {
    return {totals: 0, items: []};
  }
}

export const searchIdea = async (form, pageNo, pageSize) => {
  try {
    const res = await axios.post(`${IDEA_API_URL}/search?pageNo=${pageNo}&pageSize=${pageSize}`, form);
    return res.data.data;
  } catch (e) {
    return {totals: 0, items: []};
  }
}

export const totalViewIp = async (id) => {
  try {
    const res = await axios.get(`${STATISTIC_API_URL}/view-ip/${id}`);
    return res.data.data;
  } catch (e) {
    return {totals: 0, items: []};
  }
}

export const deleteIdea = async (id) => {
  try {
    let res = await axios.delete(`${IDEA_API_URL}/${id}`);
    return res.data.data;
  } catch (e) {
    helper.notifyError(e);
  }
}

export default {
  createIdea: createIdea,
  updateIdea: updateIdea,
  getIdea: getIdea,
  getLatest: getLatest,
  processIdea: processIdea,
  searchReviewIdea: searchReviewIdea,
  searchIdea: searchIdea,
  searchReviewIdeaToIKhien: searchReviewIdeaToIKhien,
  totalViewIp:totalViewIp,
  deleteIdea : deleteIdea
}



// WEBPACK FOOTER //
// ./src/common/idea.js